export default "assets/images/cja-5c7943c0.png";